// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { IMessageSender } from "@lib/messaging/IMessageSender";
import { NetworkSource } from "@lib/messaging/NetworkSource";
import { Socket } from "@lib/messaging/Socket";

type MessageServerContextDetails = {
  destination: NetworkSource;
  messageSender: IMessageSender;
  socket: Socket;
  source: NetworkSource;
};

/**
 * Encapsulates the context information that is associated with an incoming message.
 * Used by the `IMessageFormatProvider` to handle incoming messages.
 */
export class MessageServerContext
{
  readonly destination: NetworkSource;
  readonly messageSender: IMessageSender;
  readonly socket: Socket;
  readonly source: NetworkSource;

  constructor(details: MessageServerContextDetails)
  {
    this.destination = details.destination;
    this.messageSender = details.messageSender;
    this.socket = details.socket;
    this.source = details.source;
  }
}